import { create } from 'zustand'
import {
  createTelemetrySlice,
  type TelemetrySlice,
} from './slices/telemetrySlice'
import {
  createAgentCatalogSlice,
  type AgentCatalogSlice,
} from './slices/agentCatalogSlice'
import {
  createWorkflowsSlice,
  type WorkflowsSlice,
} from './slices/workflowsSlice'
import {
  createStreamingSlice,
  type StreamingSlice,
} from './slices/streamingSlice'
import {
  createPipelineEditorSlice,
  type PipelineEditorSlice,
} from './slices/pipelineEditorSlice'
import {
  createWorkspaceSlice,
  type WorkspaceSlice,
} from './slices/workspaceSlice'
import {
  createActivitySlice,
  type ActivitySlice,
} from './slices/activitySlice'
import {
  createOrchestratorSlice,
  type OrchestratorSlice,
} from './slices/orchestratorSlice'
import {
  createEnrichmentSlice,
  type EnrichmentSlice,
} from './slices/enrichmentSlice'
import {
  createAgentSchedulesSlice,
  type AgentSchedulesSlice,
} from './slices/agentSchedulesSlice'
import {
  createAgentRunsSlice,
  type AgentRunsSlice,
} from './slices/agentRunsSlice'

export type {
  PipelineGatherRequest,
  PipelineAnalyzeRequest,
  PipelineScanContext,
  PipelineScanAnalysis,
  PipelineFinding,
} from './slices/workflowsSlice'

export type { ActivityItem } from './slices/activitySlice'

export type CombinedSlices = TelemetrySlice & AgentCatalogSlice & WorkflowsSlice & StreamingSlice & PipelineEditorSlice & WorkspaceSlice & ActivitySlice & OrchestratorSlice & EnrichmentSlice & AgentSchedulesSlice & AgentRunsSlice
export type OrchestrationStore = CombinedSlices
export type OrchestrationState = CombinedSlices

export const useOrchestrationStore = create<CombinedSlices>()((...args) => ({
  ...createTelemetrySlice(...args),
  ...createAgentCatalogSlice(...args),
  ...createWorkflowsSlice(...args),
  ...createStreamingSlice(...args),
  ...createPipelineEditorSlice(...args),
  ...createWorkspaceSlice(...args),
  ...createActivitySlice(...args),
  ...createOrchestratorSlice(...args),
  ...createEnrichmentSlice(...args),
  ...createAgentSchedulesSlice(...args),
  ...createAgentRunsSlice(...args),
}))
